import { useEffect, useRef } from "react";
import { apiSyncCandidateAttachments } from "../api/syncCandidateAttachments";

type TSyncableCandidate = {
  id: string;
  fullLoaded?: boolean;
  attachmentsSynced?: boolean;
};

/**
 * ECO-1416: when a candidate whose Zoho attachments are not imported yet is
 * opened, asks the backend to import them (asynchronously). Only once per
 * candidate while the profile stays mounted.
 */
export const useSyncCandidateAttachmentsOnOpen = (
  candidate: TSyncableCandidate
) => {
  const requestedCandidateIds = useRef<Set<string>>(new Set());
  const { id, fullLoaded, attachmentsSynced } = candidate;

  useEffect(() => {
    // Only the fully loaded candidate tells whether its attachments are synced
    if (!fullLoaded || attachmentsSynced !== false) {
      return;
    }
    if (requestedCandidateIds.current.has(id)) {
      return;
    }

    requestedCandidateIds.current.add(id);
    apiSyncCandidateAttachments(id).catch((e) => {
      console.error(e);
    });
  }, [id, fullLoaded, attachmentsSynced]);
};
